import React from 'react';
import { FaCode, FaBullhorn, FaPalette, FaChartLine, FaLightbulb, FaPencilRuler } from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      icon: <FaCode />,
      title: 'Web Development',
      description: 'Custom websites and web applications built with cutting-edge technologies. Responsive, fast, and scalable solutions tailored to your business needs.',
      features: ['Responsive Design', 'E-commerce Solutions', 'Web Applications', 'API Integration']
    },
    {
      icon: <FaBullhorn />,
      title: 'Digital Marketing',
      description: 'Strategic digital marketing campaigns that drive growth. SEO, social media, content marketing, and paid advertising to maximize your online presence.',
      features: ['SEO Optimization', 'Social Media', 'Content Strategy', 'PPC Campaigns']
    },
    {
      icon: <FaPalette />,
      title: 'Brand Creation',
      description: 'Build a memorable brand identity that resonates with your audience. From strategy to execution, we craft brands that stand out.',
      features: ['Brand Strategy', 'Visual Identity', 'Brand Guidelines', 'Market Positioning']
    },
    {
      icon: <FaLightbulb />,
      title: 'Business Consultation',
      description: 'Expert guidance to transform your business. Strategic planning, process optimization, and growth strategies for sustainable success.',
      features: ['Strategy Planning', 'Process Optimization', 'Growth Advisory', 'Market Analysis']
    },
    {
      icon: <FaChartLine />,
      title: 'Data Analytics',
      description: 'Turn data into actionable insights. Advanced analytics, reporting, and visualization to make informed business decisions.',
      features: ['Data Visualization', 'Business Intelligence', 'Predictive Analytics', 'Custom Reports']
    },
    {
      icon: <FaPencilRuler />,
      title: 'Design Creation',
      description: 'Stunning visual designs that captivate and convert. Logos, visiting cards, brand identity, and all your design needs covered.',
      features: ['Logo Design', 'Visiting Cards', 'Brand Identity', 'Marketing Materials']
    }
  ];

  return (
    <section className="services" id="services" aria-labelledby="services-title">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Our Services</span>
          <h2 className="section-title" id="services-title">
            Complete Solutions for <span className="gradient-text">Your Success</span>
          </h2>
          <p className="section-description">
            From concept to execution, we provide comprehensive services to elevate your business
          </p>
        </div>

        <div className="services-grid" role="list">
          {services.map((service, index) => (
            <article className="service-card" key={index} role="listitem">
              <div className="service-icon" aria-hidden="true">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features" aria-label={`${service.title} features`}>
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
